module.exports = __webpack_public_path__ + "static/media/logo.ca10edf7.png";